import LoggerManager from './loggerManager.container';

export default LoggerManager;
